import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Compass, ArrowLeft, ChevronLeft, ChevronRight, Home } from "lucide-react";
import { Button } from "@/components/ui/button";
import { API } from "@/App";

const FAQPage = () => {
  const navigate = useNavigate();
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API}/content/faq`).then(r => r.json()).then(d => setContent(d.content || "")).finally(() => setLoading(false));
  }, []);

  const renderMarkdown = (md) => {
    return md.split("\n").map((line, i) => {
      if (line.startsWith("# ")) return <h1 key={i} className="font-inter font-bold text-3xl mb-6 mt-8">{line.slice(2)}</h1>;
      if (line.startsWith("## ")) return <h2 key={i} className="font-inter font-semibold text-xl mb-4 mt-8 text-purple-300">{line.slice(3)}</h2>;
      if (line.startsWith("**Q:")) return <h4 key={i} className="font-semibold text-sm mt-4 mb-1">{line.replace(/\*\*/g, "")}</h4>;
      if (line.startsWith("A:")) return <p key={i} className="text-white/50 text-sm mb-3 pl-4">{line.slice(2).trim()}</p>;
      if (line.trim() === "") return <div key={i} className="h-2" />;
      return <p key={i} className="text-white/60 text-sm mb-2 leading-relaxed">{line.replace(/\*\*/g, "")}</p>;
    });
  };

  return (
    <div className="min-h-screen bg-dark">
      <header className="border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-2">
                <Button variant="ghost" size="icon" onClick={() => navigate(-1)} className="text-white/60 hover:text-white"><ChevronLeft className="w-5 h-5" /></Button>
                <Button variant="ghost" size="icon" onClick={() => navigate(1)} className="text-white/60 hover:text-white"><ChevronRight className="w-5 h-5" /></Button>
              </div>
              <Link to="/" className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-lg bg-purple-700 flex items-center justify-center"><Compass className="w-4 h-4 text-white" /></div>
                <span className="font-inter font-bold text-lg">promptviser</span>
              </Link>
            </div>
            <Link to="/"><Button variant="ghost" size="icon" className="text-white/60 hover:text-white"><Home className="w-5 h-5" /></Button></Link>
          </div>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 md:px-12 py-12">
        <Link to="/" className="inline-flex items-center gap-2 text-white/40 hover:text-white mb-8 transition-colors text-sm">
          <ArrowLeft className="w-4 h-4" /> Back to home
        </Link>
        {loading ? (
          <div className="text-center py-12 text-white/40">Loading...</div>
        ) : (
          <div className="prose-custom">{renderMarkdown(content)}</div>
        )}
      </main>
      <footer className="border-t border-white/5 py-8">
        <div className="max-w-7xl mx-auto px-6 md:px-12 text-center text-white/30 text-xs">&copy; {new Date().getFullYear()} Promptviser.</div>
      </footer>
    </div>
  );
};

export default FAQPage;
